module.exports = __webpack_public_path__ + "static/media/new_foil.079e822f.png";